export var ConnectorNames;
(function(ConnectorNames) {
    ConnectorNames["MetaMask"] = "metaMask";
    ConnectorNames["Injected"] = "injected";
    ConnectorNames["WalletConnect"] = "walletConnect";
    ConnectorNames["EVM"] = "evm";
    ConnectorNames["Blocto"] = "blocto";
    ConnectorNames["WalletLink"] = "coinbaseWallet";
})(ConnectorNames || (ConnectorNames = {}));
